export default __webpack_public_path__ + "static/media/XEMP-2.c29cc122.jpg";